import { SORTING_DIRECTION } from '~/constants/main';
import { TBooleanInNumber } from '~/types/main';

export enum FAQSortColumn {
  NO = 'id',
}

export interface IFAQFilters {
  search: string;
  status: TBooleanInNumber | undefined;
  sortField: FAQSortColumn;
  sortDir: SORTING_DIRECTION;
}

export interface IFAQInList {
  id: number;
  order: number;
  status: TBooleanInNumber;
  question: string;
  answer: string;
}
